import Checkbox from 'components/Checkbox/Checkbox'
import Control from 'components/Control/Control'
import Divider from 'components/Divider/Divider'
import {
  ErrorTextMessage,
  FormItem,
  Heading,
} from 'modules/Onboarding/Register/PersonalInfo/style'
import moment from 'moment'
import React, { useRef, useState, useLayoutEffect, useEffect, useCallback } from 'react'
import Label from 'components/Label/Label'
import { Form } from 'antd'
import Address from 'modules/Onboarding/Register/PersonalInfoNew/Address'
import PersonalInfoForm from 'modules/Onboarding/Register/PersonalInfoNew/PersonalInfoForm'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { getValuebyName,debounce  } from '../../../../utils/helpers'
import Button from 'components/Button';
import AntdSelect from 'components/Form/Select'
import { useTpoConfig } from '../../hooks/useTpoConfig'

const initialErrorState = {
  permCountry: '',
  permState: '',
  permCity: '',
  corrCountry: '',
  corrState: '',
  corrCity: '',
}
const PersonalInfo = ({
  setCurrent,
  studentData,
  studentFormData,
  updateStudentData,
  deleteFile,
  countryList,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  updateStatusPending,
  activeKey,
  cvDetails,
  updateUserProfile,
  setActiveTab,
  onStartCvUpload,
  onCvProgress,
  onFinishCvUpload,
  updateCvDetails,
  getStudentData,
  getCities,
  registerForm,
  pendingData,
  frozenFields = {},
}) => {
  console.log(pendingData,"pendingDataRaj")
  const { frozenFields: calculatedFrozenFields } = useTpoConfig(
    studentFormData?.student?.instituteCampusId,
    studentFormData
  );

  const [form] = Form.useForm()
  
  // Register this form with the parent component for stepper validation
  useEffect(() => {
    if (typeof registerForm === 'function') {
      registerForm('personal', form);
      
      // Cleanup when component unmounts
      return () => registerForm('personal', null);
    }
  }, [form, registerForm])
  const [error, setError] = useState('')
  const formRef = useRef()
  const [file, setFile] = useState(null)
  const [countryCode, setCountryCode] = useState('91')
  const [gender, setGender] = useState('')
  const [submitLoading, setSubmitLoading] = useState(false)

  
  const [permStateList, setPermStateList] = useState([])
  const [permCityList, setPermCityList] = useState([])
  const [permCountryName, setPermCountryName] = useState('')
  const [permStateName, setPermStateName] = useState('')
  const [permCityName, setPermCityName] = useState('')
  const [permCountryId, setPermCountryId] = useState('')
  const [permStateId, setPermStateId] = useState('')
  const [permCityId, setPermCityId] = useState('')
  const [dob, setDob] = useState(null)
  const [temStateList, setTemStateList] = useState([])
  const [temCityList, setTemCityList] = useState([])
  const [temCountryName, setTemCountryName] = useState('')
  const [temStateName, setTemStateName] = useState('')
  const [temCityName, setTemCityName] = useState('')
  const [temCountryId, setTemCountryId] = useState('')
  const [temStateId, setTemStateId] = useState('')
  const [temCityId, setTemCityId] = useState('')
  const [loadingCountry, setLoadingCountry] = useState(false)
  const [loadingState, setLoadingState] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)
  const { COUNTRY_ID } = process.env

  const [isSameAddress, setIsSameAddress] = useState(
    studentFormData?.studentPersonalProfile?.isSameCorresponding
  )

  const [errorNote, setErrorNote] = useState(initialErrorState)
  const permAddressLine1 = Form.useWatch('permAddrLine1', form)
  const permAddressLine2 = Form.useWatch('permAddrLine2', form)
  const permPinCode = Form.useWatch('permPostCode', form)
  const [isAnyWhere, setIsAnyWhere] = useState(studentFormData?.studentPersonalProfile?.isAnywhere || false)
    const [locations, setLocations] = useState([])
    const [perfCityList, setPerfCityList] = useState([])

  let getCountryData = async (search, initial = false) => {
    setLoadingCountry(true)
    let list = await getListOfCountries(search, true, setLoadingCountry)
    setLoadingCountry(false)
    if (initial && search) {
      await updateCountryData(list)
    }
    return list || []
  }

  let getStateData = async (countryId, isState, search, initial = false) => {
    if (countryId) {
      setLoadingState(true)
      let list = await getListOfState(countryId, search, true, setLoadingState)
      if (initial && search) {
        await updateStateData(countryId, list)
      }
      return isState
        ? setPermStateList(list || [])
        : setTemStateList(list || [])
    }
  }

  let getCityData = async (
    countryId,
    stateId,
    isState,
    search,
    initial = false
  ) => {
    if (countryId && stateId) {
      setLoadingCity(true)
      let list = await getListOfCity(
        countryId,
        stateId,
        search,
        true,
        setLoadingCity
      )
      if (initial) {
        await updateCityData(list)
      }
      return isState ? setPermCityList(list || []) : setTemCityList(list || [])
    }
  }

  useLayoutEffect(() => {
    // Extract pending fields from pendingData first to check if we should process
    const pendingFieldsCheck = pendingData?.studentPersonalProfile?._pendingFields || {}
    const hasPendingData = Object.keys(pendingFieldsCheck).length > 0 || pendingData?.firstName || pendingData?.lastName || pendingData?.phoneNumber
    
    const formValues = form.getFieldsValue()
    const hasUserChanges = Object.keys(formValues).some(key => {
      const value = formValues[key]
      return value !== undefined && value !== null && value !== ''
    })

    // Skip if user has made changes and there's no pending data to apply
    if (hasUserChanges && !hasPendingData) {
      return 
    }

    let adminData = studentFormData?.admin
    let personalData = studentFormData?.studentPersonalProfile

    // Extract pending fields from pendingData FIRST
    // Note: firstName, lastName are at ROOT level of pendingData
    // Other fields like phoneNumber, gender, dob, addresses are inside studentPersonalProfile._pendingFields
    const pendingFields = pendingData?.studentPersonalProfile?._pendingFields || {}
    const pendingProfile = pendingData?.studentPersonalProfile || {}
    
    // Extract root-level pending fields (firstName, lastName)
    const pendingFirstName = pendingData?.firstName?.value
    const pendingLastName = pendingData?.lastName?.value
    
    // phoneNumber is in _pendingFields, not at root level
    // Remove country code prefix if present (e.g., "91 6380306094" -> "6380306094")
    let pendingPhoneNumber = pendingFields.phoneNumber?.value
    if (pendingPhoneNumber && typeof pendingPhoneNumber === 'string') {
      pendingPhoneNumber = pendingPhoneNumber.replace(/^91\s*/, '')
    }

    let cvStudentData = cvDetails?.student
    const isAnyWhere = personalData?.isAnywhere || false
    let personDetailsFromCV = {}
    if (studentData?.cvDetails?.studentPersonalProfile) {
      personDetailsFromCV = cvDetails?.studentPersonalProfile
    }
    
    let uniRollNo =
      studentFormData?.student?.uniRollNo || cvStudentData?.uniRollNo
    
    // DOB with pending data priority
    let dob = pendingFields.dob?.value || adminData?.dob || cvDetails?.admin?.dob || ''
    let formattedDOB
    if (dob && moment(dob, moment.ISO_8601, true).isValid()) {
      formattedDOB = moment(dob).format('YYYY-MM-DD')
    } else {
      formattedDOB = ''
    }
    
    let secondaryEmail =
      pendingFields.secondaryEmail?.value || personalData?.secondaryEmail || personDetailsFromCV?.secondaryEmail

    // Permanent address fields with pending data priority
    let permAddrLine1 =
      pendingFields.permAddrLine1?.value || personalData?.permAddrLine1 || personDetailsFromCV?.permAddrLine1
    let permAddrLine2 =
      pendingFields.permAddrLine2?.value || personalData?.permAddrLine2 || personDetailsFromCV?.permAddrLine2
    let permCountry =
      pendingFields.permCountry?.value || personalData?.permCountry || personDetailsFromCV?.permCountry || 'India'
    let permCountryId = pendingProfile.permCountryId || personalData?.permCountryId || COUNTRY_ID || ''
    let permState = pendingFields.permState?.value || personalData?.permState || personDetailsFromCV?.permState
    let permStateId = pendingProfile.permStateId || personalData?.permStateId
    let permCity = pendingFields.permCity?.value || personalData?.permCity || personDetailsFromCV?.permCity
    let permCityId = pendingProfile.permCityId || personalData?.permCityId
    let permPostCode = pendingFields.permPostCode?.value || personalData?.permPostCode || personDetailsFromCV?.permPostCode

    // Correspondence address fields with pending data priority
    let corrAddrLine1 = pendingFields.corrAddrLine1?.value || personalData?.corrAddrLine1
    let corrAddrLine2 = pendingFields.corrAddrLine2?.value || personalData?.corrAddrLine2
    let corrCountry = pendingFields.corrCountry?.value || personalData?.corrCountry || personDetailsFromCV?.corrCountry || 'India'
    let corrCountryId = pendingProfile.corrCountryId || personalData?.corrCountryId || COUNTRY_ID || ''
    let corrState = pendingFields.corrState?.value || personalData?.corrState || personDetailsFromCV?.corrState
    let corrStateId = pendingProfile.corrStateId || personalData?.corrStateId || ''
    let corrCity = pendingFields.corrCity?.value || personalData?.corrCity || personDetailsFromCV?.corrCity
    let corrCityId = pendingProfile.corrCityId || personalData?.corrCityId || ''
    let corrPostCode = pendingFields.corrPostCode?.value || personalData?.corrPostCode || personDetailsFromCV?.corrPostCode

    //to check the permPostCode contains 6 digits
    if (!/^\d{6}$/.test(permPostCode)) {
      permPostCode = ''
    }
    if(personDetailsFromCV?.permCountry){
      getCountryData(personDetailsFromCV?.permCountry, true)
    }
    else{
      getCountryData(permCountry,true)
    }
   

    if (studentFormData?.admin?.firstName || studentFormData?.admin?.lastName) {
      form.setFieldsValue({
        firstName: pendingFirstName || adminData?.firstName,
        lastName: pendingLastName || adminData?.lastName,
        uniRollNo: uniRollNo?.toUpperCase(),
        dob: formattedDOB ?? '',
        gender: pendingFields.gender?.value || personalData?.gender,
        profileUrl:
          studentFormData?.student?.profileUrl ||
          form.getFieldValue('profileUrl') ||
          null,
        email: adminData?.email,
        secondaryEmail,
        phoneNumber: pendingPhoneNumber || adminData?.phoneNumber,
        preferredJobLocation:studentFormData?.studentPersonalProfile?.preferredJobLocation,
        permAddrLine1,
        permAddrLine2,
        permCountry,
        permPostCode,
        permCity,
        permState,
        permCityId,
        permStateId,
        permCountryId,
        isAnyWhere,
        corrAddrLine1,
        corrAddrLine2,
        corrCountry,
        corrPostCode,
        corrCity,
        corrState,
        corrCountryId,
        corrCityId,
        corrStateId,
      })
    }
    setIsAnyWhere(isAnyWhere);
      // Set state variables (already include pending data priority)
      setPermCountryName(permCountry)
      setPermStateName(permState)
      setPermCityName(permCity)
      setPermCountryId(permCountryId)
      setPermStateId(permStateId)
      setPermCityId(permCityId)
      setTemCountryName(corrCountry)
      setTemStateName(corrState)
      setTemCityName(corrCity)
      setTemCountryId(corrCountryId)
      setTemStateId(corrStateId)
      setTemCityId(corrCityId)
      
      setPerfCityList();

      const locationPreffered =
      studentFormData?.studentPersonalProfile?.preferredJobLocation || []

    const mappedCities = locationPreffered
      .filter(city => city?.id || city?.city_id || city?.state_id)
      .map(city => ({
        value: city?.id ?? city?.city_id ?? city?.state_id,
        label: city?.name ?? city?.city_name ?? city?.state_name,
        payload: city,
      }))

    setLocations(mappedCities)
    setFile(prevFile => studentFormData?.student?.profileUrl || prevFile || null)
    setCountryCode(adminData?.country_code)
    setGender(pendingFields.gender?.value || personalData?.gender)
    setDob(formattedDOB)
    
    setIsSameAddress(personalData?.isSameCorresponding)
    if (!personalData?.isSameCorresponding) {
      getStateData(corrCountryId, false)
      getCityData(corrCountryId, corrStateId, false)
    }
  }, [studentData, studentFormData, pendingData])
  useEffect(() => {
    getStateData(permCountryId, true)
  }, [permCountryId])
  useEffect(() => {
    getStateData(temCountryId, false)
  }, [temCountryId])
  const updateCountryData = async countryList => {
    let personalData = form.getFieldValue([])

    let countryName = personalData.permCountry
    if (countryName && countryList) {
      let countryObj = getValuebyName(countryList, countryName)
      if (countryObj) {
        personalData.permCountryId = countryObj?._id
        personalData.permCountry = countryObj?.name
        await getStateData(countryObj?._id, true, personalData?.permState, true)
        setPermCountryId(countryObj?._id)
        setPermCountryName(countryObj?.name)
        form.setFieldsValue({ permCountry: personalData.permCountry })
        form.setFieldsValue({ permCountryId: personalData.permCountryId })
      } else {
        setPermCountryName('')

        form.setFieldsValue({ permCountry: '' })
        form.setFieldsValue({ permCountryId: '' })
        form.setFieldsValue({ permState: '' })
        form.setFieldsValue({ permStateId: '' })
        form.setFieldsValue({ permCity: '' })
        form.setFieldsValue({ permCityId: '' })
        setPermCityName('')
        setPermStateName('')
        setErrorNote(prevError => ({
          ...prevError,
          permCountry: `No data matched for : ${countryName}`,
        }))
        getCountryData('')
      }
    } else if (countryName) {
      setPermCountryName('')

      form.setFieldsValue({ permCountry: '' })
      form.setFieldsValue({ permCountryId: '' })
      form.setFieldsValue({ permState: '' })
      form.setFieldsValue({ permStateId: '' })
      form.setFieldsValue({ permCity: '' })
      form.setFieldsValue({ permCityId: '' })
      setPermCityName('')
      setPermStateName('')
      setErrorNote(prevError => ({
        ...prevError,
        permCountry: `No data matched for : ${countryName}`,
      }))
      getCountryData('')
    }
  }
  const updateStateData = async (countryId, stateList) => {
    let personalData = form.getFieldValue([])
    let stateName = personalData?.permState
    let stateId = personalData?.permStateId
    let cityName = personalData?.permCity || ''
    if (stateName && stateList) {
      if (!stateId) {
        let stateObj = getValuebyName(stateList, stateName)
        if (stateObj) {
          setPermStateId(stateObj?._id)
          personalData.permStateId = stateObj?._id
          personalData.permState = stateObj?.name

          form.setFieldsValue({ permState: personalData?.permState })
          form.setFieldsValue({ permStateId: personalData?.permStateId })
          await getCityData(countryId, stateObj?._id, true, cityName, true)
        } else {
          form.setFieldsValue({ permState: '' })
          form.setFieldsValue({ permStateId: '' })
          form.setFieldsValue({ permCity: '' })
          form.setFieldsValue({ permCityId: '' })
          setPermCityName('')
          setPermStateName('')
          setErrorNote(prevError => ({
            ...prevError,
            permState: `No data matched for : ${stateName}`,
          }))
          await getStateData(countryId, true, '')
        }
      }
    } else if (stateName) {
      form.setFieldsValue({ permState: '' })
      form.setFieldsValue({ permStateId: '' })
      form.setFieldsValue({ permCity: '' })
      form.setFieldsValue({ permCityId: '' })

      setPermCityName('')
      setPermStateName('')
      setErrorNote(prevError => ({
        ...prevError,
        permState: `No data matched for : ${stateName}`,
      }))
      await getStateData(countryId, true, '')
    }
  }
  const updateCityData = async cityList => {
    let personalData = form.getFieldValue([])
    let cityName = personalData.permCity
    let cityId = personalData.permCityId
    if (cityName && cityList) {
      if (!cityId) {
        let cityObj = getValuebyName(cityList, cityName)
        if (cityObj) {
          setPermCityId(cityObj?._id)
          personalData.permCityId = cityObj?._id
          personalData.permCity = cityObj?.name
          form.setFieldsValue({ permCity: personalData.permCity })
          form.setFieldsValue({ permCityId: personalData.permCityId })
        } else {
          form.setFieldsValue({ permCity: '' })
          form.setFieldsValue({ permCityId: '' })
          setPermCityName('')
          setErrorNote(prevError => ({
            ...prevError,
            permCity: `No data matched for : ${cityName}`,
          }))
          await getCityData(permCountryId, personalData?.permStateId, true)
        }
      }
    } else if (cityName) {
      form.setFieldsValue({ permCity: '' })
      form.setFieldsValue({ permCityId: '' })
      setPermCityName('')
      setErrorNote(prevError => ({
        ...prevError,
        permCity: `No data matched for : ${cityName}`,
      }))
      await getCityData(permCountryId, personalData?.permStateId, true)
    }
  }

  // useLayoutEffect(() => {
  //   let values = form.getFieldValue([])
  //   getCountryData(values?.permCountry, true)
  // }, [])
  const isAnyWhereOnChange = data => {
    setIsAnyWhere(data?.target?.checked)
    form.setFieldsValue({
      isAnyWhere: data?.target?.checked,
    })
  }

  const locationHandler = (selectedValues, selectedOptions) => {
    const selectedPayloads = selectedOptions?.map(item => item.option)

    form.setFieldsValue({
      preferredJobLocation: selectedPayloads,
    })
    setLocations(selectedPayloads)
  }

   useEffect(() => {
      delayCitiesToDbForPreferredLocationSearch('')
    }, [])

     const delayCitiesToDbForPreferredLocationSearch = useCallback(
        debounce(async search => {
          try {
            let list = await getCities(search)
    
            const newOptions = [
              ...list.cities.map(city => ({
                value: city.city_id,
                label: city.city_name,
                type: 'city',
                payload: city,
              })),
              ...list.states.map(state => ({
                value: state.state_id,
                label: state.state_name,
                type: 'state',
                payload: state,
              })),
            ]
            setPerfCityList(newOptions)
          } catch (error) {
            console.error('Error fetching cities:', error)
          }
        }, 300),
        []
      )
  const onChangeGender = data => {
    form.setFieldsValue({ gender: data })
    setGender(data)
  }

  const validateDateOfBirth = dateString => {
    const date = moment(dateString, 'DD/MM/YYYY', true)
    return date.isValid()
  }
  const onDateChange = (date, dateString) => {
    const isValidDate = validateDateOfBirth(dateString)
    const modifiedDateFormat = date ? moment(date).format('YYYY-MM-DD') : null
    if (!isValidDate) {
      form.setFieldsValue({ dob: null })
      setDob(null)
      setError('Please enter a valid date of birth (DD/MM/YYYY)')
    }
    if (isValidDate) {
      form.setFieldsValue({ dob: modifiedDateFormat })
      setDob(modifiedDateFormat)
      setError('')
    }
  }

  const uploadProfile = async (profileUrl = null) => {
    setFile(profileUrl)

    let payload = {
      url: profileUrl,
    }
    let response = await updateUserProfile(studentData?.id, payload)
    return response
  }

  const onRemoveImage = async () => {
    let response = deleteFile(file)
    if (response) {
      const studentResponse = await uploadProfile()
      if (studentResponse) {
        form.setFieldsValue({ profileUrl: '' })
        SuccessMessage('File deleted successfully!')
      }
    } else {
      ErrorMessage('Failed to delete the file!')
    }
  }

  const onCountryCodeChange = data => {
    form.setFieldsValue({ country_code: data })
    setCountryCode(data)
  }

  const onCountryChange = (data, option) => {
    form.setFieldsValue({
      permCountry: data,
      permState: '',
      permCity: '',
      permCountryId: option?.option?._id,
      permStateId: '',
      permCityId: '',
    })
    formRef.current.setFields([
      {
        name: 'permCountry',
        errors: [],
      },
    ])
    setErrorNote(initialErrorState)

    setPermCountryName(data)
    setPermCountryId(option?.option?._id)
    setPermStateName('')
    setPermStateId('')
    setPermCityName('')
    if (!data) getCountryData('')
    if (option) getStateData(option?.option?._id, true)
    isSameAddress && onCurentCountryChange(data, option)
  }

  const onCurentCountryChange = (data, option) => {
    form.setFieldsValue({
      corrCountry: data,
      corrState: '',
      corrCity: '',
      corrCountryId: option?.option?._id,
      corrStateId: '',
      corrCityId: '',
    })
    formRef.current.setFields([
      {
        name: 'corrCountry',
        errors: [],
      },
    ])
    setTemCountryName(data)
    setTemCountryId(option?.option?._id)
    setTemStateId('')
    setTemStateName('')
    setTemCityName('')

    if (!isSameAddress && option) getStateData(option?.option?._id, false)
  }

  const onStateChange = async (data, option) => {
    form.setFieldsValue({
      permState: data,
      permCity: '',
      permStateId: option?.option?._id,
      permCityId: '',
    })
    formRef.current.setFields([
      {
        name: 'permState',
        errors: [],
      },
    ])
    setErrorNote(prevError => ({
      ...prevError,
      state: '',
      city: '',
    }))
    setPermStateName(data)
    setPermStateId(option?.option?._id)
    setPermCityName('')
    setPermCityId('')
    if (!data) getStateData(permCountryId, true)
    await getCityData(permCountryId, option?.option?._id, true)
    isSameAddress && onCurrentStateChange(data, option)
  }

  const onCurrentStateChange = (data, option) => {
    form.setFieldsValue({
      corrState: data,
      corrCity: '',
      corrStateId: option?.option?._id,
      corrCityId: '',
    })
    formRef.current.setFields([
      {
        name: 'corrState',
        errors: [],
      },
    ])
    setTemStateId(option?.option?._id)
    setTemStateName(data)
    setTemCityName('')
    if (!isSameAddress) {
      getStateData(temCountryId, false)
      getCityData(temCountryId, option?.option?._id, false)
    }
  }

  const onCityChange = (data, option) => {
    form.setFieldsValue({ permCity: data, permCityId: option?.option?._id })
    formRef.current.setFields([
      {
        name: 'permCity',
        errors: [],
      },
    ])
    setErrorNote(prevError => ({
      ...prevError,
      city: '',
    }))
    setPermCityName(data)
    setPermCityId(option?.option?._id)
    getCityData(permCountryId, permStateId, true)
    isSameAddress && onCurrentCityChange(data, option)
  }
  const onCurrentCityChange = (data, option) => {
    form.setFieldsValue({ corrCity: data, corrCityId: option?.option?._id })
    formRef.current.setFields([
      {
        name: 'corrCity',
        errors: [],
      },
    ])
    setTemCityName(data)
    setTemCityId(option?.option?._id)
    !isSameAddress && getCityData(temCountryId, temStateId, false)
  }

  const sameAddressOnChange = data => {
    setIsSameAddress(data?.target?.checked)
    if (data?.target?.checked) {
      setTemCountryName(permCountryName)
      setTemStateName(permStateName)
      setTemCityName(permCityName)
      setTemCountryId(permCountryId)
      setTemStateId(permStateId)
      setTemCityId(permCityId)
      form.setFieldsValue({
        corrAddrLine1: permAddressLine1,
        corrAddrLine2: permAddressLine2,
        corrCountry: permCountryName,
        corrState: permStateName,
        corrCity: permCityName,
        corrCountryId: permCountryId,
        corrStateId: permStateId,
        corrCityId: permCityId,
        corrPostCode: permPinCode,
      })
    } else {
      setTemCountryName('')
      setTemStateName('')
      setTemCityName('')
      setTemStateList([])
      setTemCityList([])
      getCountryData()
      form.setFieldsValue({
        corrAddrLine1: '',
        corrAddrLine2: '',
        corrCountry: '',
        corrState: '',
        corrCountryId: '',
        corrStateId: '',
        corrCityId: '',
        corrPostCode: '',
        corrCity: '',
      })
    }
  }
  const isCorporateMasterExist = (value, name) => {
    return !form.getFieldValue(name + 'Id')
  }

  useEffect(() => {
    form.setFieldsValue({ profileUrl: file })
  }, [file])

  const submitHandler = async values => {
    if (!values?.dob) {
      setError('Please enter a date of birth')
    } else {
      setError('')
    }
    // Expected date format
    const expectedFormat = 'YYYY-MM-DD'

    let studentDateOfBirth = moment(
      studentFormData?.admin?.dob,
      expectedFormat,
      true
    )
    // Attempt to parse the date string with the expected format
    const parsedDate = moment(values?.dob, expectedFormat, true)

    // Store form values and state variables in localStorage for persistence
    const formDataToStore = {
      ...values,
      permCountryName, permStateName, permCityName,
      permCountryId, permStateId, permCityId,
      temCountryName, temStateName, temCityName,
      temCountryId, temStateId, temCityId
    }
    localStorage.setItem(`personalInfo_${studentData?.id}`, JSON.stringify(formDataToStore))

    setSubmitLoading(true)
    
    let payload = {
      admin: {
        email: values?.email,
        phoneNumber: values?.phoneNumber,
        firstName: values?.firstName,
        lastName: values?.lastName,
        dob:
          studentFormData?.admin?.dob === values?.dob
            ? studentDateOfBirth.isValid()
              ? studentFormData?.admin?.dob
              : moment(studentFormData?.admin?.dob).format('YYYY-MM-DD')
            : parsedDate.isValid()
            ? values?.dob
            : moment(values?.dob).format('YYYY-MM-DD'),
        gender: values?.gender,
        countryCode: studentFormData?.admin?.countryCode,
      },
      student: {
        ...studentFormData?.student,
        uniRollNo: values?.uniRollNo,
        passedOut:
          typeof studentFormData?.student?.passedOut === 'boolean'
            ? studentFormData?.student?.passedOut
            : false,
        profileUrl: values?.profileUrl,
      },
      studentPersonalProfile: {
        ...studentFormData?.studentPersonalProfile,
        secondaryEmail: values?.secondaryEmail || null,
        permAddrLine1: values?.permAddrLine1,
        permAddrLine2: values?.permAddrLine2,
        permCity: permCityName,
        permState: permStateName,
        permPostCode: values?.permPostCode,
        permCountry: permCountryName,
        permCityId: permCityId,
        permStateId: permStateId,
        permCountryId: permCountryId,
        isSameCorresponding: isSameAddress,
        corrAddrLine1: values?.corrAddrLine1,
        corrAddrLine2: values?.corrAddrLine2,
        corrCity: temCityName,
        corrState: temStateName,
        corrPostCode: isSameAddress
          ? values?.permPostCode
          : values?.corrPostCode,
        corrCountry: temCountryName,
        corrCityId: temCityId,
        corrStateId: temStateId,
        corrCountryId: temCountryId,
        preferredJobLocation:  values?.preferredJobLocation?.map(item => item.payload ?? item) || [],
        isAnywhere: isAnyWhere,
      },
      currentCourse: !studentFormData?.student?.isExpCandidate
        ? studentFormData?.currentCourse
        : {},
      degreeStreamMap:
        !studentFormData?.student?.isExpCandidate &&
        studentFormData?.currentCourse?.degreeId &&
        studentFormData?.currentCourse?.streamId
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},

      education: studentFormData?.education,
      resume: studentFormData?.resume,
      checkDeleteSection: ["studentPersonalProfile"],
      checkForApproval: true
      }

    if (payload?.currentCourse?.specialisationId === null) {
      delete payload?.currentCourse?.specialisationId
    }
    if (payload?.currentCourse?.degreeStreamMapId === null) {
      delete payload?.currentCourse?.degreeStreamMapId
    }

    if (payload?.currentCourse?.skills === null) {
      delete payload?.currentCourse?.skills
    }
    studentFormData?.education.map((item, index) => {
      if (item?.skills === null) delete payload?.education[index]?.skills
      if (item?.markSheetUrl === null)
        delete payload?.education[index]?.markSheetUrl
      if (item?.degreeStreamMapId === null)
        delete payload?.education[index]?.degreeStreamMapId
    })
    if (values?.dob) {
      let response = await updateStudentData(payload)
      if (response?.success === true) {
        await getStudentData()
        SuccessMessage('Personal info saved successfully!')
        setSubmitLoading(false)
        if (studentData?.status == 0) {
          updateStatusPending(studentData?.id)
        }
        setActiveTab('education')
      } else {
        setSubmitLoading(false)
        ErrorMessage(response?.response?.data?.message)
      }
    }
  }
  const scrollToFirstError = errors => {
    const firstErrorField = errors?.[errors?.length - 1]
    if (firstErrorField) {
      const firstErrorField1 = firstErrorField.name.join('.')
      formRef.current.scrollToField(firstErrorField1)
    }
  }

  const handlePinCode = e => {
    const pincodeValue = e.target.value ? parseInt(e.target.value, 10) : null
    if (isSameAddress) {
      form.setFieldValue('permPostCode', pincodeValue)
      form.setFieldValue('corrPostCode', pincodeValue)
    } else form.setFieldValue(e.target.id, pincodeValue)
  }
  return (
    <div id="personalFormScroll">
      <Form
        scrollToFirstError
        onFinish={submitHandler}
        id={'personalForm'}
        form={form}
        ref={formRef}
        onFinishFailed={({ errorFields }) => {
          scrollToFirstError(errorFields)
        }}
        layout="vertical"
      >
        <PersonalInfoForm
          form={form}
          onChangeGender={onChangeGender}
          gender={gender}
          setGender={setGender}
          file={file}
          setFile={uploadProfile}
          studentFormData={studentFormData}
          studentData={studentData}
          onCountryCodeChange={onCountryCodeChange}
          countryCode={countryCode}
          onRemoveImage={onRemoveImage}
          onDateChange={onDateChange}
          error={error}
          setError={setError}
          dob={dob}
          onStartCvUpload={onStartCvUpload}
          onCvProgress={onCvProgress}
          onFinishCvUpload={onFinishCvUpload}
          updateCvDetails={updateCvDetails}
          getStudentData={getStudentData}
          updateStudentData={updateStudentData}
          frozenFields={calculatedFrozenFields}
        />

        <Address
          loadingCountry={loadingCountry}
          loadingState={loadingState}
          loadingCity={loadingCity}
          setLoadingCountry={setLoadingCountry}
          setLoadingState={setLoadingState}
          setLoadingCity={setLoadingCity}
          form={form}
          countryList={countryList}
          stateList={permStateList || []}
          cityList={permCityList || []}
          onCountryChange={onCountryChange}
          onStateChange={onStateChange}
          onCityChange={onCityChange}
          heading={'Permanent Address'}
          address1Name={'permAddrLine1'}
          address2Name={'permAddrLine2'}
          countryName={'permCountry'}
          stateName={'permState'}
          cityName={'permCity'}
          pincode={'permPostCode'}
          secondAddress1Name={'corrAddrLine1'}
          secondAddress2Name={'corrAddrLine2'}
          // secondPincode={'corrPostCode'}
          isTemAddress={false}
          isSameAddress={isSameAddress}
          countryValue={permCountryName}
          stateValue={permStateName}
          cityValue={permCityName}
          countryId={permCountryId}
          stateId={permStateId}
          cityId={permCityId}
          getStateData={getStateData}
          getCityData={getCityData}
          isCorporateMasterExist={isCorporateMasterExist}
          errorNote={errorNote}
          setErrorNote={setErrorNote}
          getListOfCountries={getCountryData}
          setStateName={setPermStateName}
          setStateId={setPermStateId}
          setCountryName={setPermCountryName}
          setCountryId={setPermCountryId}
          setCityName={setPermCityName}
          setCityId={setPermCityId}
          handlePinCode={handlePinCode}
          frozenFields={calculatedFrozenFields}
        />
        <Control top="35px" spaceBetween>
          <Heading>Current Address</Heading>
          <Checkbox
            label={'Same as permanent address'}
            onChange={sameAddressOnChange}
            value={isSameAddress}
            disabled={
              (calculatedFrozenFields?.permCountry || calculatedFrozenFields?.permState || calculatedFrozenFields?.permCity) &&
              (calculatedFrozenFields?.corrCountry || calculatedFrozenFields?.corrState || calculatedFrozenFields?.corrCity)
            }
          />
        </Control>
        <Address
          form={form}
          loadingCountry={loadingCountry}
          loadingState={loadingState}
          loadingCity={loadingCity}
          setLoadingCountry={setLoadingCountry}
          setLoadingState={setLoadingState}
          setLoadingCity={setLoadingCity}
          countryList={countryList}
          stateList={temStateList}
          cityList={temCityList}
          onCountryChange={onCurentCountryChange}
          onStateChange={onCurrentStateChange}
          onCityChange={onCurrentCityChange}
          heading={null}
          address1Name={'corrAddrLine1'}
          address2Name={'corrAddrLine2'}
          countryName={'corrCountry'}
          stateName={'corrState'}
          cityName={'corrCity'}
          pincode={'corrPostCode'}
          isTemAddress={true}
          isSameAddress={isSameAddress}
          countryValue={temCountryName}
          stateValue={temStateName}
          cityValue={temCityName}
          countryId={temCountryId}
          stateId={temStateId}
          cityId={temCityId}
          getStateData={getStateData}
          getCityData={getCityData}
          isCorporateMasterExist={isCorporateMasterExist}
          errorNote={errorNote}
          setErrorNote={setErrorNote}
          getListOfCountries={getCountryData}
          setStateName={setTemStateName}
          setStateId={setTemStateId}
          setCountryName={setTemCountryName}
          setCountryId={setTemCountryId}
          setCityName={setTemCityName}
          setCityId={setTemCityId}
          handlePinCode={handlePinCode}
          frozenFields={calculatedFrozenFields}
        />

           {/* Preferred Job Location */}
           <Control column top="10px" width="49%">
              <Label>Preferred Location *</Label>
              <Control column bottom="10px">
                <Checkbox onChange={isAnyWhereOnChange} value={isAnyWhere} label={'Anywhere'} />
              </Control>

              {!isAnyWhere && (
                <>
                  <FormItem
                    style={{ height: '10px' }}
                    name={'preferredJobLocation'}
                  >
                    <div></div>
                  </FormItem>

                  <AntdSelect
                    placeholder="Eg.Chennai"
                    name={'preferredJobLocation'}
                    rules={[
                      {
                        validator: async (_, value) => {
                          if (
                            !locations?.length &&
                            (!Array.isArray(value) || value?.length === 0)
                          ) {
                            return Promise.reject(
                              new Error('Please enter preferred job location!')
                            )
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}
                    OptionData={perfCityList}
                    filterOption={false}
                    onChange={locationHandler}
                    value={locations}
                    mode="multiple"
                    maxTagCount={3}
                    valueParam="value"
                    nameParam="label"
                    showSearch={true}
                    iskey={true}
                    onSearch={data =>
                      delayCitiesToDbForPreferredLocationSearch(data)
                    }
                    // onDropdownVisibleChange={open => {
                    //   if (!open) {
                    //     delayCitiesToDbForPreferredLocationSearch('')
                    //     form.setFieldsValue({
                    //       preferredJobLocation: locations,
                    //     })
                    //   }
                    // }}
                  />
                </>
              )}
            </Control>
        <Divider />
        {/* <ErrorTextMessage>
          <FormItem
            name={'profileUrl'}
            padding={true}
            rules={[
              {
                required: true,
                message: 'Please Upload Image!',
              },
            ]}
          />
        </ErrorTextMessage> */}

        <Control top="25px" flexEnd gap="15px">
          {/* <Button.Secondary
            text="Back"
            onClick={() => setCurrent(activeKey - 1)}
          /> */}
          <Button.Primary
            text="Next"
            htmlType={'submit'}
            disable={submitLoading}
          />
        </Control>
      </Form>
    </div>
  )
}

export default PersonalInfo
